<template>
  <div class="module-properties">
    <div class="form-group">
      <label>Tipo de Join</label>
      <select v-model="config.joinType">
        <option value="inner">Inner Join</option>
        <option value="left">Left Join</option>
        <option value="right">Right Join</option>
        <option value="full">Full Join</option>
      </select>
    </div>
    
    <div class="form-group">
      <label>Campo da Fonte Principal</label>
      <input type="text" v-model="config.leftField" placeholder="Campo da fonte principal">
    </div>
    
    <div class="form-group">
      <label>Campo da Fonte Secundária</label>
      <input type="text" v-model="config.rightField" placeholder="Campo da fonte secundária">
    </div>
    
    <div class="form-group">
      <label>Prefixo para Campos da Fonte Principal</label>
      <input type="text" v-model="config.leftPrefix" placeholder="Ex: main_">
    </div>
    
    <div class="form-group">
      <label>Prefixo para Campos da Fonte Secundária</label>
      <input type="text" v-model="config.rightPrefix" placeholder="Ex: sec_">
    </div>
    
    <div class="form-group">
      <label>Manter Apenas Campos Selecionados</label>
      <input type="checkbox" v-model="config.keepSelectedFieldsOnly">
    </div>
    
    <div class="form-group" v-if="config.keepSelectedFieldsOnly">
      <label>Campos a Manter (separados por vírgula)</label>
      <input type="text" v-model="config.fieldsToKeep" placeholder="campo1, campo2, campo3">
    </div>
  </div>
</template>

<script>
export default {
  name: 'JoinModuleProperties',
  props: {
    module: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      config: {
        joinType: 'inner',
        leftField: '',
        rightField: '',
        leftPrefix: '',
        rightPrefix: '',
        keepSelectedFieldsOnly: false,
        fieldsToKeep: '',
        ...this.module.config
      }
    };
  },
  watch: {
    config: {
      handler(newConfig) {
        this.$emit('update:config', newConfig);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.module-properties {
  padding: 10px;
}
.form-group {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
select, input[type="text"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
